module.exports = __webpack_public_path__ + "img/tuceng19.134a646c.png";